import { createStore } from 'vuex'
import { MailOutlined, AppstoreAddOutlined, FlagOutlined, FieldTimeOutlined, UserSwitchOutlined } from '@ant-design/icons-vue';

export default createStore({
  state: {
    menus: [
      {
        path: '/datelist',
        name: 'DateList',
        meta: { title: '日期管理', icon: () => <FieldTimeOutlined /> },
        // component: () => import('../views/taskManage/index.vue'),
        children: []
      },
      {
        path: '/pointlist',
        name: 'PointList',
        meta: { title: '点位管理', icon: () => <FlagOutlined /> },
        children: []
      },
      {
        path: '/applylist',
        name: 'ApplyList',
        meta: { title: '申请管理', icon: () => <AppstoreAddOutlined /> },
        children: []
      },
      {
        path: '/userllist',
        name: 'UserList',
        meta: { title: '用户管理', icon: () => <UserSwitchOutlined /> },
        children: []
      },
    ]
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
